import React, { createContext, useContext } from 'react';

import { DocumentDto } from '../../../../api/models';

interface DocumentContextType {
    document: DocumentDto;
    getCurrentMarkdown?: () => string;
}

const DocumentContext = createContext<DocumentContextType | null>(null);

export const DocumentProvider: React.FC<{
    children: React.ReactNode;
    document: DocumentDto;
    getCurrentMarkdown?: () => string;
}> = ({ children, document, getCurrentMarkdown }) => {
    return (
        <DocumentContext.Provider value={{ document, getCurrentMarkdown }}>
            {children}
        </DocumentContext.Provider>
    );
};

export const useDocumentContext = () => {
    const context = useContext(DocumentContext);
    if (!context) {
        throw new Error(
            'useDocumentContext must be used within a DocumentProvider'
        );
    }
    return context;
};
